import React, {PropsWithChildren} from 'react'
import classNames from 'classnames'
import ChevronUp from 'wix-ui-icons-common/on-stage/ChevronUp'
import ChevronDown from 'wix-ui-icons-common/on-stage/ChevronDown'
import {TextButton} from 'wix-ui-tpa/cssVars'
import {ExpansionButtonProps} from './interfaces'
import {classes} from './expansion-button.st.css'

export const ExpansionButton: React.FC<PropsWithChildren<ExpansionButtonProps>> = ({
  children,
  className,
  dataHook,
  expanded,
  onChange,
}) => {
  return (
    <TextButton
      data-hook={dataHook}
      aria-expanded={expanded}
      className={classNames(classes.root, className)}
      onClick={() => onChange(!expanded)}
    >
      {children}
      <div className={classes.chevron}>
        {expanded ? <ChevronUp className={classes.icon} /> : <ChevronDown className={classes.icon} />}
      </div>
    </TextButton>
  )
}
